import { motion } from 'framer-motion';

export const GlassCard = ({ children, className = '', hover = true, accentColor, ...props }) => {
  return (
    <motion.div
      className={`
        relative overflow-hidden rounded-3xl
        bg-white/[0.03] backdrop-blur-xl
        border border-white/[0.08]
        transition-all duration-300
        ${hover ? 'hover:border-brand-green/40 hover:shadow-[0_0_30px_rgba(124,58,237,0.1)]' : ''}
        ${className}
      `}
      style={accentColor ? { '--accent': accentColor } : undefined}
      whileHover={hover ? { y: -4 } : undefined}
      transition={{ duration: 0.2 }}
      {...props}
    >
      {children}
    </motion.div>
  );
};
